import styled from 'styled-components';
import { ITheme, IThemeProvider } from '../../../../../styles/theme';

interface ICardNavButton {
  theme: ITheme;
  $active?: boolean;
}

// Same segmented control as the Internal / External and Reports setup / Participants switches.
export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  box-sizing: border-box;
  ${({ theme }: IThemeProvider) => `
    border-radius: ${theme.layout.spacing.mili};
    background: rgba(24, 58, 96, 0.07);
  `}
`;

export const CardButtonsCont = styled.div`
  position: relative;
  display: flex;
`;

export const CardNavButton = styled.button<ICardNavButton>`
  margin: 0;
  padding: 6px 14px;
  border: none;
  border-radius: 9px;
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  text-transform: capitalize;
  cursor: pointer;
  user-select: none;
  transition:
    background 0.15s,
    color 0.15s,
    box-shadow 0.15s;

  ${({ theme, $active: active }: ICardNavButton) => `
    background: ${active ? theme.colors.neutral.primary[0] : 'transparent'};
    color: ${active ? theme.colors.secondary[100] : theme.colors.neutral.primary[70]};
    font-weight: ${active ? 600 : 400};
    box-shadow: ${active ? '0 1px 2px rgba(24, 58, 96, 0.12), 0 1px 1px rgba(24, 58, 96, 0.06)' : 'none'};

    &:hover {
      color: ${theme.colors.secondary[100]};
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px ${theme.colors.primary[30]};
    }
  `}
`;
